/* NutriFitt buy kit: cart drawer, sticky buy bar, ritual bundles, shopper signals. */
(function () {
  'use strict';
  if (window.NFB && window.NFB.ready) return;
  var D = document, W = window;
  var CFG = {};
  try { var dataEl = D.getElementById('NfbData'); CFG = dataEl ? JSON.parse(dataEl.textContent) : {}; } catch (e) { CFG = {}; }
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || CFG.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var TH = Number(CFG.threshold || 0);
  var CUR = CFG.currency || 'USD';
  var state = { cart: null, lastFocus: null };
  var ARROW = '<span aria-hidden="true">↗</span>';

  function q(s, r) { return (r || D).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    var amount = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = CFG.moneyFormat || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      return amount;
    });
  }
  function request(path, body) {
    var opts = { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) {
      if (body instanceof FormData) opts.body = body;
      else { opts.body = JSON.stringify(body); opts.headers['Content-Type'] = 'application/json'; }
    }
    return fetch(ROOT + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'We could not update your cart. Please try again.');
        return j;
      });
    });
  }
  function syncCounts(c) {
    qa('[data-cart-count], [data-nfb-count], .cart-link__count, .cart-count, [data-header-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    ['cart:refresh', 'cart:updated', 'theme:cart:change'].forEach(function (n) { try { D.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: c } })); } catch (e) {} });
  }
  function getCart() { return request('cart.js').then(function (c) { state.cart = c; syncCounts(c); return c; }); }

  /* ---------- signals for retargeting (Klaviyo + Meta) ---------- */
  function trackAdd(res) {
    var added = (res && (res.items || [res])) || [];
    try {
      var k = W.klaviyo || (W.klaviyo = []);
      added.forEach(function (it) {
        if (!it || !it.product_title) return;
        k.push(['track', 'Added to Cart', { '$value': it.final_line_price / 100, AddedItemProductName: it.product_title, AddedItemProductID: it.product_id, AddedItemVariantID: it.variant_id, AddedItemSKU: it.sku, AddedItemImageURL: it.image, AddedItemURL: location.origin + it.url, AddedItemPrice: it.final_price / 100, AddedItemQuantity: it.quantity, CheckoutURL: location.origin + ROOT + 'checkout', Source: CFG.context || '' }]);
      });
    } catch (e) {}
  }
  function signals() {
    var m = CFG.main;
    if (!m || !CFG.viewContent) return;
    var v = m.variants.filter(function (x) { return x.available; })[0] || m.variants[0];
    try { if (typeof W.fbq === 'function') W.fbq('track', 'ViewContent', { content_ids: [String(v.id)], content_type: 'product', content_name: m.title, value: v.price / 100, currency: CUR }); } catch (e) {}
    try { var k = W.klaviyo || (W.klaviyo = []); k.push(['track', 'Viewed Product', { ProductName: m.title, ProductID: m.id, ImageURL: m.image, URL: location.origin + m.url, Price: v.price / 100, Source: CFG.context || '' }]); } catch (e) {}
  }

  /* ---------- drawer ---------- */
  function drawer() { return q('[data-nfb-drawer]'); }
  function open() {
    var d = drawer(); if (!d) return;
    if (!d.classList.contains('is-open')) state.lastFocus = D.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    D.documentElement.classList.add('nfb-locked');
    var p = q('.nfb-panel', d); if (p) setTimeout(function () { p.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    D.documentElement.classList.remove('nfb-locked');
    if (state.lastFocus && state.lastFocus.focus) { try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function upCard(p, v, kicker, label) {
    var avail = p.variants.filter(function (x) { return x.available; });
    var pick = avail.length > 1 && !label
      ? '<select class="nfb-select nfb-select--xs" data-nfb-up-variant aria-label="' + esc(p.optionName || 'Option') + '">' + avail.map(function (x) { return '<option value="' + x.id + '" data-price="' + x.price + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.label || x.title) + '</option>'; }).join('') + '</select>'
      : '<input type="hidden" data-nfb-up-variant value="' + v.id + '">';
    var image = v.image || p.image;
    var name = label || p.title;
    return '<div class="nfb-up">' + (image ? '<img src="' + esc(image) + '" alt="" loading="lazy" width="120" height="120">' : '<span></span>') +
      '<div class="nfb-up-info">' + (kicker ? '<span class="nfb-up-kick">' + esc(kicker) + '</span>' : '') + '<strong>' + esc(name) + '</strong><span class="nfb-up-price">' + money(v.price) + '</span>' + pick + '</div>' +
      '<button type="button" class="nfb-up-add" data-nfb-up-add aria-label="Add ' + esc(name) + '">Add</button></div>';
  }
  function upsellHTML(c) {
    var inCart = {};
    (c.items || []).forEach(function (it) { (inCart[it.product_id] = inCart[it.product_id] || []).push(it.variant_id); });
    var cards = [];
    var main = CFG.main;
    if (main && inCart[main.id] && main.variants.length > 1) {
      var other = main.variants.filter(function (v) { return v.available && inCart[main.id].indexOf(v.id) < 0; })[0];
      if (other) cards.push(upCard(main, other, CFG.doubleKicker || 'Run both flavors', main.title + ' · ' + other.title));
    }
    (CFG.upsells || []).forEach(function (p) {
      if (cards.length >= 3 || !p || !p.available || inCart[p.id]) return;
      var v = p.variants.filter(function (x) { return x.available; })[0];
      if (v) cards.push(upCard(p, v, p.kicker || '', ''));
    });
    if (!cards.length) return '';
    return '<section class="nfb-ups" aria-label="' + esc(CFG.upsellTitle || 'Complete the ritual') + '"><p class="nfb-ups-head">' + esc(CFG.upsellTitle || 'Complete the ritual') + '</p><div class="nfb-ups-row">' + cards.join('') + '</div></section>';
  }
  function lineHTML(it) {
    var variant = (!it.product_has_only_default_variant && it.variant_title) ? '<span class="nfb-line-var">' + esc(it.variant_title) + '</span>' : '';
    var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? '<span class="nfb-line-var">' + esc(it.selling_plan_allocation.selling_plan.name) + '</span>' : '';
    return '<li class="nfb-line" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
      '<a class="nfb-line-img" href="' + esc(it.url) + '" tabindex="-1">' + (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="" width="76" height="76" loading="lazy">' : '') + '</a>' +
      '<div class="nfb-line-info"><a class="nfb-line-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + plan +
      '<div class="nfb-qty"><button type="button" data-nfb-qty="-1" aria-label="Remove one">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-nfb-qty="1" aria-label="Add one">+</button></div></div>' +
      '<div class="nfb-line-price">' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + '<strong>' + money(it.final_line_price) + '</strong><button type="button" class="nfb-remove" data-nfb-remove>Remove</button></div></li>';
  }
  function render(c) {
    var d = drawer(); if (!d || !c) return;
    var ship = q('[data-nfb-ship]', d), body = q('[data-nfb-body]', d), foot = q('[data-nfb-foot]', d);
    var count = q('[data-nfb-drawer-count]', d); if (count) count.textContent = c.item_count ? '(' + c.item_count + ')' : '';
    if (ship) {
      if (CUR === 'USD' && TH > 0 && c.item_count) {
        var left = TH - c.total_price, pct = Math.max(4, Math.min(100, c.total_price / TH * 100));
        ship.innerHTML = (left > 0 ? '<p>Add <b>' + money(left) + '</b> more for <b>free US shipping</b></p>' : '<p class="is-won"><b>Free US shipping</b> unlocked</p>') + '<div class="nfb-meter' + (left > 0 ? '' : ' is-full') + '"><span style="width:' + pct + '%"></span></div>';
        ship.hidden = false;
      } else ship.hidden = true;
    }
    if (!c.item_count) {
      body.innerHTML = '<div class="nfb-empty"><p>Your cart is empty.</p></div>' + upsellHTML(c);
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = '<ul class="nfb-lines">' + c.items.map(lineHTML).join('') + '</ul>' + upsellHTML(c);
    var pay = q('template[data-nfb-pay]');
    foot.innerHTML = '<div class="nfb-sub"><span>Subtotal</span><strong>' + money(c.total_price) + '</strong></div>' +
      (c.total_discount ? '<p class="nfb-save">You save ' + money(c.total_discount) + '</p>' : '') +
      '<a class="nfb-btn nfb-checkout" href="' + ROOT + 'checkout"><span>Secure checkout</span>' + ARROW + '</a>' +
      '<div class="nfb-pay">' + (pay ? pay.innerHTML : '') + '</div>' +
      '<p class="nfb-fine">Taxes and shipping calculated at checkout</p>' +
      '<button type="button" class="nfb-keep" data-nfb-close>Keep shopping</button>';
  }
  function refresh() { return getCart().then(function (c) { render(c); return c; }); }
  function toast(msg) {
    var t = q('[data-nfb-toast]');
    if (!t) { t = D.createElement('div'); t.className = 'nfb-toast'; t.setAttribute('data-nfb-toast', ''); t.setAttribute('role', 'status'); D.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-busy', !!on);
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    else { btn.removeAttribute('aria-busy'); btn.disabled = false; }
  }
  function hasCorner() { return !!(W.isCornerAppEmbedsTurnedOn || W.CornerWebComponentsAPI || D.querySelector('.widgets-by-corner')); }
  function add(items, btn) {
    busy(btn, true);
    var body = items instanceof FormData ? items : { items: items };
    return request('cart/add.js', body)
      .then(function (res) { trackAdd(res); return getCart(); })
      .then(function (c) { render(c); if (!hasCorner()) open(); return c; })
      .catch(function (err) { toast(err.message || 'Could not add to cart'); throw err; })
      .then(function (c) { busy(btn, false); return c; }, function (err) { busy(btn, false); throw err; });
  }
  function change(key, qty) {
    var d = drawer(); if (d) d.classList.add('is-loading');
    return request('cart/change.js', { id: key, quantity: qty })
      .then(function (c) { state.cart = c; syncCounts(c); render(c); })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (d) d.classList.remove('is-loading'); });
  }

  /* ---------- sticky buy bar ---------- */
  function initSticky() {
    qa('[data-nfb-sticky]').forEach(function (bar) {
      var targets = [];
      (bar.getAttribute('data-watch') || '').split(',').forEach(function (s) { s = s.trim(); if (s) qa(s).forEach(function (el) { targets.push(el); }); });
      var visible = new Map();
      var instant = bar.hasAttribute('data-instant');
      function update() {
        var any = false; visible.forEach(function (v) { if (v) any = true; });
        var cs = D.getElementById('corner-sticky-atc-outer-container');
        var other = !!(cs && cs.classList.contains('opacity-100') && cs.getBoundingClientRect().height > 0);
        var show = !any && !other && (instant || W.scrollY > 240);
        bar.classList.toggle('is-on', show);
        if (show) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
        else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
      }
      if ('IntersectionObserver' in W && targets.length) {
        var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { visible.set(e.target, e.isIntersecting); }); update(); }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
        targets.forEach(function (t) { visible.set(t, false); io.observe(t); });
      }
      W.addEventListener('scroll', function () { update(); clearTimeout(bar._t); bar._t = setTimeout(update, 380); }, { passive: true });
      setTimeout(update, 400);
      var sel = q('[data-nfb-sticky-variant]', bar), price = q('[data-nfb-sticky-price]', bar);
      if (sel && sel.tagName === 'SELECT') sel.addEventListener('change', function () { var o = sel.options[sel.selectedIndex]; if (o && price) price.textContent = o.getAttribute('data-price'); });
    });
  }

  /* ---------- ritual bundle ---------- */
  function ritualUpdate(box) {
    var total = 0, count = 0, items = qa('[data-nfb-ritual-item]', box);
    items.forEach(function (item) {
      var pick = q('[data-nfb-pick]', item), vs = q('[data-nfb-variant]', item);
      var opt = vs && vs.tagName === 'SELECT' ? vs.options[vs.selectedIndex] : vs;
      var price = Number((opt && opt.getAttribute('data-price-cents')) || 0);
      var on = !pick || pick.checked;
      item.classList.toggle('is-off', !on);
      var pr = q('[data-nfb-ritual-price]', item); if (pr) pr.textContent = money(price);
      if (on) { total += price; count++; }
    });
    var t = q('[data-nfb-ritual-total]', box); if (t) t.textContent = money(total);
    var s = q('[data-nfb-ritual-ship]', box);
    if (s && TH > 0 && CUR === 'USD') { s.textContent = total >= TH ? 'Free US shipping included' : money(TH - total) + ' away from free US shipping'; s.classList.toggle('is-won', total >= TH); }
    var b = q('[data-nfb-ritual-add]', box);
    if (b) { b.disabled = !count; var l = q('[data-nfb-ritual-label]', b); if (l) l.textContent = count === items.length ? (box.getAttribute('data-label-all') || 'Add the full ritual') : (count ? 'Add ' + count + (count > 1 ? ' items' : ' item') : 'Pick an item'); }
  }

  /* ---------- events ---------- */
  D.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var el;
    if ((el = t.closest('[data-nfb-close]'))) { e.preventDefault(); close(); return; }
    if ((el = t.closest('[data-nfb-open]')) || (CFG.cartLinks && !hasCorner() && (el = t.closest('a[href$="/cart"]')) && !t.closest('[data-nfb-drawer]'))) { e.preventDefault(); refresh().then(open); return; }
    if ((el = t.closest('[data-nfb-qty]'))) { var li = el.closest('[data-key]'); change(li.getAttribute('data-key'), Math.max(0, Number(li.getAttribute('data-qty')) + Number(el.getAttribute('data-nfb-qty')))); return; }
    if ((el = t.closest('[data-nfb-remove]'))) { change(el.closest('[data-key]').getAttribute('data-key'), 0); return; }
    if ((el = t.closest('[data-nfb-up-add]'))) { var c = el.closest('.nfb-up'); var vv = q('[data-nfb-up-variant]', c); add([{ id: Number(vv.value), quantity: 1 }], el).catch(function () {}); return; }
    if ((el = t.closest('[data-nfb-sticky-add]'))) { var bar = el.closest('[data-nfb-sticky]'); var sv = q('[data-nfb-sticky-variant]', bar); add([{ id: Number(sv.value), quantity: 1 }], el).catch(function () {}); return; }
    if ((el = t.closest('[data-nfb-add]'))) { e.preventDefault(); var id = el.getAttribute('data-variant-id'); var scope = el.closest('[data-nfb-add-scope]'); var s2 = scope && q('[data-nfb-add-variant]', scope); add([{ id: Number(s2 ? s2.value : id), quantity: Number(el.getAttribute('data-qty') || 1) }], el).catch(function () {}); return; }
    if ((el = t.closest('[data-nfb-ritual-add]'))) {
      var box = el.closest('[data-nfb-ritual]'); var list = [];
      qa('[data-nfb-ritual-item]', box).forEach(function (item) { var pick = q('[data-nfb-pick]', item); if (pick && !pick.checked) return; var v = q('[data-nfb-variant]', item); if (v && v.value) list.push({ id: Number(v.value), quantity: 1 }); });
      if (list.length) add(list, el).catch(function () {});
      return;
    }
    // intercept theme add-to-cart buttons
    if (CFG.intercept && (el = t.closest('button[type="submit"], input[type="submit"]'))) {
      var f = el.form || el.closest('form');
      if (f && /\/cart\/add/.test(f.getAttribute('action') || '') && !f.closest('[data-nfb-skip]')) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        if (f.reportValidity && !f.reportValidity()) return;
        add(new FormData(f), el).catch(function () {});
      }
    }
  }, true);
  D.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (!(CFG.intercept || f.hasAttribute('data-nfb-form')) || f.closest('[data-nfb-skip]')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    add(new FormData(f), q('[type="submit"]', f)).catch(function () {});
  }, true);
  D.addEventListener('change', function (e) {
    var t = e.target; if (!(t instanceof Element)) return;
    var box = t.closest('[data-nfb-ritual]'); if (box) ritualUpdate(box);
    if (t.matches('[data-nfb-up-variant]')) { var o = t.options[t.selectedIndex]; var pr = t.closest('.nfb-up').querySelector('.nfb-up-price'); if (o && pr) pr.textContent = money(o.getAttribute('data-price')); }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var d = drawer(); if (d && d.classList.contains('is-open')) close(); } });

  function init() {
    qa('[data-nfb-drawer], [data-nfb-sticky]').forEach(function (el) { if (el.parentNode !== D.body) D.body.appendChild(el); });
    qa('[data-nfb-ritual]').forEach(ritualUpdate);
    initSticky();
    signals();
    var idle = W.requestIdleCallback || function (fn) { setTimeout(fn, 1200); };
    idle(function () { getCart().then(render).catch(function () {}); });
  }
  W.NFB = { ready: true, add: add, open: open, close: close, refresh: refresh, money: money, toast: toast };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
